import * as franchisePageActions from '../../action_creators/franchise/franchise_page_data_action_creators';
import log from '../../../services/logger_service';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import get from 'lodash/get';
import FranchisePageModel from '../../../models/franchise/franchise_page_model';
import axios from 'axios';
import https from 'https';

function fetchFranchisePageData(params, store) {
  return FranchisePageModel.fetch(params, store)
    .then(function handleFranchisePageData(FranchisePageData) {
      return FranchisePageData;
    })
    .catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        log.warn('User tried a World Changing Ideas page with invalid year.');
        return false;
      }
      log.warn('Something went wrong loading World Changing Ideas.');
      return false;
    });
}

function getExternalList(params) {
  const { slug } = params;
  const httpsAgent = new https.Agent({
    rejectUnauthorized: false
  });
  if (slug === 'next-big-things-in-tech/2021') {
    return axios.get(`https://tempo.inc.com/nextbusiness/final`, {
      httpsAgent
    });
  }

  if (slug === 'q50-2022') {
    return axios.get(`https://tempo.inc.com/q502022/final`, {
      httpsAgent
    });
  }

  if (slug === 'q50-2023') {
    return axios.get(`https://tempo.inc.com/q50-2023/final`, {
      httpsAgent
    });
  }

  if (slug === 'mcp-2022') {
    return axios.get(`https://tempo.inc.com/mcp-2022/final`, {
      httpsAgent
    });
  }

  if (slug === 'mcp-2023') {
    return axios.get(`https://tempo.inc.com/mcp-2023/final`, {
      httpsAgent
    });
  }

  if (slug === 'bwi-2022') {
    return axios.get(`https://tempo.inc.com/bwi-2022/final`, {
      httpsAgent
    });
  }

  if (slug === 'bwi-2023') {
    return axios.get(`https://tempo.inc.com/bwi-2023/final`, {
      httpsAgent
    });
  }

  if (slug === 'ibd-2022-2') {
    return axios.get(`https://tempo.inc.com/ibd-2022/final`, {
      httpsAgent
    });
  }

  if (slug === 'creator25') {
    return axios.get(
      `https://assets.fastcompany.com/multisite_files/fastcompany/creator-25/2022_c25_records.json`,
      {
        httpsAgent
      }
    );
  }

  if (slug === 'next-big-things-in-tech/list') {
    return axios.get(`https://tempo.inc.com/nbtt-2022/final`, {
      httpsAgent
    });
  }

  return Promise.resolve(null);
}

function getFranchiseCategory(params) {
  const { slug } = params;
  switch (slug) {
    case 'q50-2022':
      return 'queer-50';

    default:
      return slug;
  }
}

export default function fetchFranchisePage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(franchisePageActions.franchisePageLoading({}, store));

    const asyncActions = [
      fetchFranchisePageData(params, store),
      asyncRecircFeedActions(params, store)(dispatch),
      getExternalList(params, store)
    ];

    return Promise.all(asyncActions)
      .then(function handlePostDetailData(data) {
        const pageData = get(data, '[0].data', {});
        const pageType = `${get(pageData, 'type', '')}-${get(
          pageData,
          'slug',
          ''
        )}`;
        pageData.externalList = get(data, '[2].data', null);
        pageData.franchiseCategory = getFranchiseCategory(params);
        dispatch(
          franchisePageActions.franchisePageLoaded(pageData, store, pageType)
        );
        return pageData;
      })
      .catch(function handleUserError(err) {
        dispatch(franchisePageActions.franchisePageLoadError(err, store));
        return log.error(
          err,
          `Error in Franchise page actions, message: ${err.message}`
        );
      });
  };
}
